import io from "socket.io-client";
// import baseUrl from "./main.js";
// console.log(baseUrl);
let token = localStorage.getItem("token");
// const socketConnection = io("https://ppkbaas.satrapp.com", {
const socketConnection = io("https://baas.ppk.satr.app", {
  auth: {
    token: token,
  },
}); // Also declared in main.js as baseUrl
// const socketConnection = io("http://192.168.43.143:3004", {
//   auth: {
//     token: token,
//   },
// });

export default socketConnection;
